import React from 'react';
import { Download, Send, Loader2, ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

/** In-app PDF viewer with Download + Send actions. */
export const PdfPreviewDialog = ({ open, onOpenChange, url, title, fileName, onSend, sending }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-5xl w-[96vw] h-[92vh] p-0 flex flex-col gap-0" data-testid="dp-pdf-dialog">
      <DialogHeader className="px-4 sm:px-6 py-3 border-b flex flex-col sm:flex-row sm:items-center justify-between gap-2 space-y-0 pr-14">
        <DialogTitle className="text-base sm:text-lg truncate">{title}</DialogTitle>
        <div className="flex flex-wrap items-center gap-2 shrink-0">
          {url && (
            <>
              <Button asChild variant="outline" size="sm" data-testid="dp-pdf-open">
                <a href={url} target="_blank" rel="noreferrer"><ExternalLink className="h-4 w-4 mr-1.5" />Open</a>
              </Button>
              <Button asChild variant="outline" size="sm" data-testid="dp-pdf-download">
                <a href={url} download={fileName}><Download className="h-4 w-4 mr-1.5" />Download</a>
              </Button>
            </>
          )}
          {onSend && (
            <Button size="sm" className="bg-blue-600 hover:bg-blue-700 text-white" onClick={onSend} disabled={sending} data-testid="dp-pdf-send">
              {sending ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Send className="h-4 w-4 mr-1.5" />}
              Send to driver
            </Button>
          )}
        </div>
      </DialogHeader>
      <div className="flex-1 min-h-0 bg-slate-100 dark:bg-slate-900">
        {url ? <iframe src={url} title={title} className="w-full h-full" data-testid="dp-pdf-iframe" /> : (
          <div className="h-full flex items-center justify-center text-slate-500"><Loader2 className="h-6 w-6 animate-spin" /></div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
